// Stundenlohn und Brutto-Vorschau.
//
// Zweck: zwei Minijobber werden nach Stunden bezahlt (Björn 2026-08-13). Die Vorschau
// ist eine REINE RECHENHILFE zur Kontrolle vor der Lohnmeldung — keine Lohnabrechnung:
// Zuschläge (Nacht/Sonntag/Feiertag), Abzüge, Zulagen und Pauschalen bleiben außen vor.
// Deshalb steht sie auch nicht im DATEV-Export, sondern nur auf dem Bildschirm.

/**
 * Bruttolohn aus Ist-Minuten und Stundenlohn, auf Cent gerundet.
 * Ohne hinterlegten Lohn null — nicht 0, denn „kein Satz hinterlegt" und
 * „verdient nichts" sind zwei verschiedene Aussagen.
 */
export function bruttoVorschau(istMinuten: number, stundenlohn: number | null | undefined): number | null {
  const satz = Number(stundenlohn);
  if (stundenlohn == null || !Number.isFinite(satz) || satz < 0) return null;
  const minuten = Number.isFinite(istMinuten) ? Math.max(0, istMinuten) : 0;
  return Math.round((minuten / 60) * satz * 100) / 100;
}

/** Betrag deutsch formatiert; null wird zum Gedankenstrich. */
export function euroText(betrag: number | null | undefined): string {
  if (betrag == null || !Number.isFinite(Number(betrag))) return '—';
  return `${Number(betrag).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
}
